import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HistoricoMovimientos } from '../../modelos/Control_Usuario/historico-movimiento';

@Injectable({
  providedIn: 'root',
})
export class HistoricoMovimientosService {
  //Url del back
  private urlApi: string = environment.urlback + '/HistoricoMovimientos';

  constructor(private http: HttpClient) {}

  /**Inserta una solicitud */
  public create(solicitud: HistoricoMovimientos) {
    return this.http.post<HistoricoMovimientos>(`${this.urlApi}`, solicitud);
  }
  getAll(): Observable<HistoricoMovimientos[]> {
    return this.http.get<HistoricoMovimientos[]>(`${this.urlApi}`);
  }
  getAById(id: number): Observable<HistoricoMovimientos[]> {
    return this.http.get<HistoricoMovimientos[]>(`${this.urlApi}/${id}`);
  }
  public update(solicitud: HistoricoMovimientos, id: number) {
    return this.http.put<HistoricoMovimientos>(
      `${this.urlApi}/${id}`,
      solicitud
    );
  }
}
